// src/stores/useWellfinderAoiPref.js
//
// The reviewer's last operating AOI, remembered across sessions.
//
// WHY A STORE FOR ONE STRING. It is not the string, it is the classification:
// persistKeys.test.js fails CI unless every persist-backed store's localStorage
// name appears in exactly one scope list, and USER_SCOPED is what makes this
// survive the analyst's own logout/login while being wiped when a DIFFERENT
// user signs in on the same browser. Writing to localStorage directly would
// have skipped that guard entirely — and the guard exists because a hand-kept
// wipe list had already drifted twice.
//
// THIS IS NOT THE FILTER. The review page's filters live in the URL, which is
// the single source of truth there and carries a warning about how many places
// already have to agree about one. This store seeds that URL on arrival and
// nothing else: it never applies a filter itself, so there is no second
// authority to drift from.
//
// Null means "no preference recorded" AND "explicitly all AOIs". They produce
// the same behaviour — no AOI applied — so there is nothing to tell apart.

import { create } from "zustand";
import { persist } from "zustand/middleware";
import { PERSIST_KEYS } from "../auth/persistKeys";

export const useWellfinderAoiPref = create(
  persist(
    (set) => ({
      lastAoiId: null,
      rememberAoi: (id) => set({ lastAoiId: id ?? null }),
    }),
    { name: PERSIST_KEYS.wellfinderAoi },
  ),
);
